import { faCheck, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './TimelineStopGraphic.scss';

interface TimelineStopGraphicProps {
  label: string;
  sublabel: string;
  position: StopPositions;
  icon: StopIcons;
  color: StopColors;
}

export enum StopPositions {
  Start,
  Middle,
  End,
}

export enum StopIcons {
  None,
  Checkmark,
  LocationPin,
}

export enum StopColors {
  LightGray,
  DarkGray,
  Verdigris,
}

export const STOP_DONE = {
  icon: StopIcons.Checkmark,
  color: StopColors.DarkGray,
};

export const STOP_CURRENT = {
  icon: StopIcons.LocationPin,
  color: StopColors.Verdigris,
};

export const STOP_TO_DO = {
  icon: StopIcons.None,
  color: StopColors.LightGray,
};

export default function TimelineStopGraphic(props: TimelineStopGraphicProps) {
  const { label, sublabel, position, icon, color } = props;
  const getShapeBorderClass = (stopPosition: StopPositions) => {
    switch (stopPosition) {
      case StopPositions.Start:
        return 'timeline-stop-graphic__shape--rounded-left';
      case StopPositions.End:
        return 'timeline-stop-graphic__shape--rounded-right';
      default:
        return '';
    }
  };
  const getShapeColorClass = (color: StopColors) => {
    switch (color) {
      case StopColors.LightGray:
        return 'timeline-stop-graphic__shape--light-gray';
      case StopColors.DarkGray:
        return 'timeline-stop-graphic__shape--dark-gray';
      case StopColors.Verdigris:
        return 'timeline-stop-graphic__shape--verdigris';
    }
  };
  const getIcon = (icon: StopIcons) => {
    switch (icon) {
      case StopIcons.Checkmark:
        return faCheck;
      case StopIcons.LocationPin:
        return faLocationDot;
      default:
        throw new Error('Icon unrecognized, must be an icon listed in StopIcons enum');
    }
  };
  return (
    <div className="timeline-stop-graphic">
      <div className={`timeline-stop-graphic__shape ${getShapeBorderClass(position)} ${getShapeColorClass(color)}`}>
        {icon !== StopIcons.None && <FontAwesomeIcon icon={getIcon(icon)} color={'white'} size={'2x'} />}
      </div>
      <div className="timeline-stop-graphic__label">
        <span className="label__text">{label}</span>
        <br />
        <span className="label__text--emph">{sublabel}</span>
      </div>
    </div>
  );
}
